import React, { useEffect } from 'react';
import ZenPopScanter from '../components/ZenPopScanter';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import { useLocation } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import queryString from 'query-string';


const AutoScanter = ({
    method,
    api,
    urlData,
    scanterCallback = () => { },
    setPageHeader,
    pageName = 'Auto Scanter',
}) => {
    const scanter = {
        "buttonProp": {
            "type": "primary",
            "label": "Scan Here",
            "visible": true,
            "enable": true,
            "validateFields": false,
            "confirmationPopUp": false,
            "submitFormData": true,
            "popUpModal": false,
            "postSubmitAction": false
        },
        "submitFormDataProp": {
            "method": method || "POST",
            "api": api || "/test",
            "params": {
                "param1": "p1",
                "param2": "p2"
            }
        }
    }
    const { search } = useLocation();
    const [loading, setLoading] = React.useState(true);
    const searchParams = queryString.parse(search);

    useEffect(() => {
        if (setPageHeader) {
            setLoading(true);
            liracrypt.get("/smt/autoscanterpagetitle", { ...searchParams, ...urlData })
                .then(({ data }) => {
                    setLoading(false);
                    if (data.isSuccess) {
                        setPageHeader(data.config.pageTitle);
                    }
                }).catch(err => {
                    ApiErrorComp();
                    console.log(err);
                })
        }
    }, [search]);


    return (
        <div className='auto-scanter'>
            {
                loading ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                        <LoadingOutlined
                            style={{ fontSize: 80, color: "#007bff" }}
                            spin
                        />
                    </div> :
                    <ZenPopScanter
                        scanter={scanter}
                        urlData={urlData}
                        scanterCallback={() => { }}
                    />
            }

        </div>
    )
};

export default AutoScanter;